<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>渠道账号</h1>
        <p>渠道老板和子账号。登录账号为手机号；改密码请到「渠道管理」操作列。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">账号数</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">在用</div><div class="v">{{ active }}</div></div>
      <div class="ch-metric"><div class="k">停用</div><div class="v">{{ list.length - active }}</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>渠道</th><th>姓名</th><th>登录账号</th><th>岗位</th><th>手机</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.partnerName || '—' }}</td>
            <td>{{ row.realName || '—' }}</td>
            <td>{{ row.username }}</td>
            <td>{{ row.title || '—' }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 1 ? 'ok' : 'muted'">{{ row.status === 1 ? '在用' : '停用' }}</span></td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">还没有渠道账号</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelStaff } from '@/api/admin'

export default {
  name: 'HqAccounts',
  data() { return { list: [] } },
  computed: {
    active() { return this.list.filter(item => item.status === 1).length }
  },
  created() { this.load() },
  methods: {
    async load() {
      const result = await getChannelStaff()
      this.list = result.list || []
    }
  }
}
</script>
